// Translations
import form from '../sections/form/translations/tr'

// Translation: Reset > Landing (Turkish)
export default Object.freeze({
	sections: { form }
})
